// extracted by mini-css-extract-plugin
export default {"container":"ModalContainer_container__++2mJ"};